import React, { useEffect, useRef, useState, useMemo } from 'react';
import { useLocation, useNavigate, useOutletContext, useSearchParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { ErrorMessage, Field, Form, Formik, useFormik } from 'formik';
import * as Yup from 'yup';
import 'bootstrap/dist/css/bootstrap.min.css';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import * as XLSX from 'xlsx';
import autoTable from 'jspdf-autotable';
import { SlPrinter } from "react-icons/sl";
import { AiOutlineFileExcel } from "react-icons/ai";
import { FaRegFilePdf } from "react-icons/fa";
import { CommonAxiosGet, CommonAxiosPost } from '../CommonAxios/CommonAxios';
import { config } from '../CommonUrl/CommonUrls';

export default function DynamicShowReportNew() {

    let CONTEXT_NAME = 'KGBV';
    // const { endpoint, serviceID } = useOutletContext();
    // const { endpoint, serviceID } = useOutletContext() || {};
const location = useLocation();
const endpoint = location?.state?.endpoint;
const serviceID = location?.state?.serviceID;
    const [dataSet, setDataSet] = useState(null);
    // const apiEndPoint = endpoint?.find(s => s.service_id === serviceID);
    const apiEndPoint = endpoint?.showreport_list?.find(
    s => Number(s.service_id) === Number(serviceID)
);
    const dispatch = useDispatch();
    const navigate = useNavigate();
   

    const [searchParams] = useSearchParams();
    const typee = searchParams.get('reportType');

    const [dynamicOptions, setDynamicOptions] = useState({});
    const [localFilters, setLocalFilters] = useState({});
    const [fetchTrigger, setFetchTrigger] = useState(0);
console.log("endpoint", endpoint);
console.log("serviceID", serviceID);
console.log("apiEndPoint", apiEndPoint);
    const filterSchema = useMemo(() => {
        try {
            if (apiEndPoint?.form_config) {
                return JSON.parse(apiEndPoint?.form_config);
            }
            return [];
        } catch (e) {
            console.error("Error parsing form_config JSON:", e);
            return [];
        }
    }, [apiEndPoint]);

    useEffect(() => {
        if (filterSchema && filterSchema?.length > 0) {
            filterSchema.forEach(async (f) => {
                if (f?.apiEndpoint && !f?.dependsOn && (!f?.options || f?.options?.length === 0)) {
                    try {
                        const res = await CommonAxiosGet(config?.url?.CONTEXT_READ_URL + f?.apiEndpoint);
                        // const responseData = res.data;

                        // const keys = Object.keys(responseData);

                        // const dataKey = keys.find(key =>
                        //     key !== "status" &&
                        //     !key.toLowerCase().endsWith("size") &&
                        //     Array.isArray(responseData[key])
                        // );

                        // const finalData = dataKey ? responseData[dataKey] : [];

                        setDynamicOptions(prev => ({ ...prev, [f?.id]: res?.data?.data || [] }));
                    } catch (err) {
                        console.error("Initial load error", err);
                    }
                }
            });
        }
    }, [filterSchema]);

    const handleLocalFilterChange = (key, value) => {
        setLocalFilters(prev => ({ ...prev, [key]: value }));
    };

    const handleGetReport = () => {
        setFetchTrigger(prev => prev + 1);
    };

    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [searchInput, setSearchInput] = useState('');
    const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });

    const [currentValue, setCurrentValue] = useState(0);
    const [scale, setScale] = useState(1);

    useEffect(() => {
        const savedFilters = sessionStorage.getItem(`filters_${serviceID}`);
        if (savedFilters) {
            const parsedFilters = JSON.parse(savedFilters);
            setLocalFilters(parsedFilters);

            if (!typee) {
                setFetchTrigger(prev => (prev === 0 ? 1 : prev + 1));
            }
        }
    }, [serviceID]);

    useEffect(() => {
        return () => {
            sessionStorage.removeItem(`filters_${serviceID}`);
        };
    }, [serviceID]);

    useEffect(() => {
        if (!endpoint) return;

        if (!typee && !apiEndPoint?.api_end_point) return;

        const hasFilters = filterSchema && filterSchema?.length > 0;

        if (!typee && hasFilters && fetchTrigger === 0) {
            return;
        }

        const fetchData = async () => {
            try {
                const formData = new FormData();
              let decodedReportType = typee ? atob(typee) : "";

               let url = typee
  ? `${config?.url?.CONTEXT_READ_URL}${decodedReportType}`
  : `${config?.url?.CONTEXT_READ_URL}${apiEndPoint?.api_end_point}`;

                if (typee) {
                    // const qp = new URLSearchParams();
                    searchParams.forEach((value, key) => {
                        if (key !== 'reportType') {
                            // qp.append(key, value);
                            formData.append(key, value);
                        }
                    });

                    Object.entries(localFilters).forEach(([key, value]) => {
                        if (value) {
                            formData.append(key, value);
                        }
                    });

                    // const qs = qp.toString();
                    // if (qs) url += url.includes('?') ? `&${qs}` : `?${qs}`;
                } else {
                    const qp = new URLSearchParams();
                    Object.entries(localFilters).forEach(([key, value]) => {
                        if (value) qp.append(key, value);
                    });
                    const qs = qp.toString();
                    if (qs) url += url.includes('?') ? `&${qs}` : `?${qs}`;
                }

                const response = await CommonAxiosPost(url, formData);

                setDataSet(response?.data);
            } catch (error) {
                console.error("API Call error:", error);
                setDataSet(null);
            }
        };

        fetchData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [apiEndPoint, typee, endpoint, filterSchema, fetchTrigger, localFilters, location.search, searchParams]);

    const {
        data = [], headings = [], headings1 = [], headings2 = [], headings3 = [],
        links = [], aligns = [], totals = [], datatypes = [], displays = [],
        tablehead, reportgeneratedtime, pagination, search, isSerialNoReq
    } = dataSet || {};

    useEffect(() => {
        if (!data.length) return;
        let startValue = 0;
        const targetValue = data.length;
        const stepTime = 2000 / 200;

        const timer = setInterval(() => {
            startValue += (targetValue / 200);
            if (startValue >= targetValue) {
                clearInterval(timer);
                setCurrentValue(targetValue);
            } else {
                setCurrentValue(Math.round(startValue));
                setScale(prev => (prev === 1 ? 1.1 : 1));
            }
        }, stepTime);

        return () => clearInterval(timer);
    }, [data]);

    const processedData = useMemo(() => {
        let sortableData = [...data];
        if (searchInput) {
            sortableData = sortableData.filter(row =>
                row.some(cell => String(cell).toUpperCase().includes(searchInput.toUpperCase()))
            );
        }
        if (sortConfig.key !== null) {
            sortableData.sort((a, b) => {
                const valueA = String(a[sortConfig.key] || '').trim();
                const valueB = String(b[sortConfig.key] || '').trim();
                if (sortConfig.direction === 'asc') return valueA.localeCompare(valueB, undefined, { numeric: true, sensitivity: 'base' });
                else return valueB.localeCompare(valueA, undefined, { numeric: true, sensitivity: 'base' });
            });
        }
        return sortableData;
    }, [data, searchInput, sortConfig]);

    const totalItems = processedData.length;
    const isPaginationEnabled = pagination === 'true';
    const activeItemsPerPage = itemsPerPage === 'All' ? totalItems : itemsPerPage;
    const totalPages = isPaginationEnabled ? Math.ceil(totalItems / (activeItemsPerPage || 1)) : 1;
    const startIndex = (currentPage - 1) * activeItemsPerPage;
    const slicedData = isPaginationEnabled ? processedData.slice(startIndex, startIndex + activeItemsPerPage) : processedData;
    const formatNumberWithCommas = (num) => new Intl.NumberFormat('en-IN').format(num);

    const renderMultiHeader = (headersObj) => {
        if (!headersObj || headersObj.length === 0) return null;
        return (
            <tr>
                {headersObj.map((head, index) => {
                    const [colSpan, rowSpan, label] = head.split('#');
                    return (
                        <th key={index}  colSpan={Number(colSpan)} rowSpan={Number(rowSpan)} style={{ textAlign: 'center', backgroundColor: '#f8f9fa', color: '#333' }}>
                            <span dangerouslySetInnerHTML={{ __html: label }} />
                        </th>
                    );
                })}
            </tr>
        );
    };

    const getFormattedTimestamp = () => {
        return new Date().toLocaleString('en-IN', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: true, }).replace(/[^\d]/g, '');
    };

    const handlePrint = () => {
        const tableHTML = document.getElementById("DataTable").outerHTML;
        const newWindow = window.open('', '', 'width=900, height=600');
        newWindow.document.write('<html><head><title>Print Report</title>');
        newWindow.document.write('<style>table { width: 100%; border-collapse: collapse; font-family: Arial, sans-serif; font-size: 12px; } th, td { border: 1px solid #dddddd; padding: 8px; text-align: left; } th { background-color: #f2f2f2; }</style>');
        newWindow.document.write('</head><body>');
        // newWindow.document.write(`<h2 style="text-align:center; font-family: Arial;">${tablehead}</h2>`);
        newWindow.document.write(tableHTML);
        newWindow.document.write('</body></html>');
        newWindow.document.close();
        newWindow.focus();
        newWindow.print();
        newWindow.close();
    };

    const handleExcelDownload = () => {
        const table = document.getElementById("DataTable");
        if (!table) return;

        const wb = XLSX.utils.table_to_book(table, { sheet: "Report Data" });

        // XLSX.writeFile(wb, "Report_Data.xlsx");
        XLSX.writeFile(wb, `${tablehead}_${getFormattedTimestamp()}.xlsx`);
    };
    
    const handlePDFDownload = () => {
        if (!data || data.length === 0) return;

        const doc = new jsPDF('landscape');
        const totalPagesExp = '{total_pages_count_string}';

        autoTable(doc, {
            html: '#DataTable',
            theme: 'grid',
            styles: {
                fontSize: 8,
                cellPadding: 2,
                lineColor: [255, 255, 255],
                lineWidth: 0.1,
            },
            headStyles: {
                halign: 'center',
                valign: 'middle',
            },
            bodyStyles: {
                valign: 'middle',
            },
            margin: { top: 20, bottom: 20 },

            didDrawPage: function (data) {
                doc.setFontSize(10);
                const pageSize = doc.internal.pageSize;
                const pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight();

                let str = "Page " + doc.internal.getNumberOfPages();

                if (typeof doc.putTotalPages === 'function') {
                    str = str + " of " + totalPagesExp;
                }

                doc.text(str, data.settings.margin.left, pageHeight - 10);
            },
        });

        if (typeof doc.putTotalPages === 'function') {
            doc.putTotalPages(totalPagesExp);
        }

        // autoTable(doc, {
        //     html: '#DataTable',
        //     startY: 20,
        //     styles: { fontSize: 8 },
        //     // headStyles: { fillColor: [2, 108, 61], textColor: [255, 255, 255] }
        // });


        doc.save(`${tablehead}_${getFormattedTimestamp()}.pdf`);
    };

    const handleDynamicChange = async (e, filterItem, setFieldValue, values) => {
        const selectedValue = e.target.value;

        setFieldValue(filterItem.id, selectedValue);

        const updatedValues = { ...values, [filterItem.id]: selectedValue };

        const dependentFilters = filterSchema.filter(f =>
            f.dependsOn && f.dependsOn.includes(filterItem.id)
        );

        dependentFilters.forEach(async (childFilter) => {
            setFieldValue(childFilter.id, '');

            const hasStaticOptions = childFilter.options && childFilter.options.length > 0;

            if (!hasStaticOptions) {
                const allParentsSelected = childFilter.dependsOn.every(pId => updatedValues[pId]);

                if (allParentsSelected && childFilter.apiEndpoint) {
                    try {
                        const queryParams = childFilter.dependsOn.map(pId => `${pId}=${updatedValues[pId]}`).join('&');

                        const res = await CommonAxiosGet(config.url.CONTEXT_READ_URL + `${childFilter.apiEndpoint}?${queryParams}`);
                        // const responseData = res.data;

                        // const keys = Object.keys(responseData);

                        // const dataKey = keys.find(key =>
                        //     key !== "status" &&
                        //     !key.toLowerCase().endsWith("size") &&
                        //     Array.isArray(responseData[key])
                        // );

                        // const finalData = dataKey ? responseData[dataKey] : [];
                        setDynamicOptions(prev => ({
                            ...prev, [childFilter.id]: res?.data?.data || []
                        }));
                    } catch (err) {
                        console.error(`${childFilter.id} fetch error:`, err);
                        setDynamicOptions(prev => ({ ...prev, [childFilter.id]: [] }));
                    }
                } else {
                    setDynamicOptions(prev => ({ ...prev, [childFilter.id]: [] }));
                }
            }
        });
    };

    const handlePageChange = (pageNumber) => {
        if (pageNumber >= 1 && pageNumber <= totalPages) {
            setCurrentPage(pageNumber);
        }
    };

    const paginationControls = () => {
        const pagesToShow = 3;
        let startPage = Math.max(1, currentPage - Math.floor(pagesToShow / 2));
        let endPage = Math.min(startPage + pagesToShow - 1, totalPages);

        if (endPage - startPage + 1 < pagesToShow) {
            startPage = Math.max(1, endPage - pagesToShow + 1);
        }

        const pages = Array.from({ length: endPage - startPage + 1 }, (_, index) => startPage + index);
        // const pages = [];
        // for (let i = startPage; i <= endPage; i++) {
        //     pages.push(i);
        // }
        // console.log("pages", pages)
        return (
            <nav aria-label="Page navigation">
                <div className="d-flex align-items-center justify-content-end gap-3" style={{ flexDirection: 'row' }}>
                    <span className="text-muted fw-bold" style={{ fontSize: '0.8rem' }}>
                        Total Pages: {totalPages}
                    </span>
                    <ul className="pagination pagination-sm mb-0 shadow-sm" style={{ flexDirection: 'row' }}>
                        <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                            <button className="page-link shadow-none px-3" onClick={() => handlePageChange(currentPage - 1)}>
                                Previous
                            </button>
                        </li>
                        {pages.map((page) => (
                            <li key={page} className={`page-item ${page === currentPage ? 'active' : ''}`}>
                                <button className="page-link shadow-none px-3" onClick={() => handlePageChange(page)}>
                                    {page}
                                </button>
                            </li>
                        ))}
                        <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                            <button className="page-link shadow-none px-3" onClick={() => handlePageChange(currentPage + 1)}>
                                Next
                            </button>
                        </li>
                    </ul>
                </div>
            </nav>
        );
    };

    return (
        <div style={{ marginTop: '20px' }}>
            {!typee && (<>
                {filterSchema && filterSchema.length > 0 && (
                    <div className="card mb-4 shadow-sm" style={{ border: 'none', borderRadius: '8px' }}>
                        <div className="card-body px-4 py-3">
                            <Formik
                                enableReinitialize={true}
                                initialValues={
                                    Object.keys(localFilters).length > 0 ? localFilters
                                        : (filterSchema?.reduce((acc, filter) => {
                                            acc[filter.id] = '';
                                            return acc;
                                        }, {}) || {})
                                }
                                validationSchema={
                                    Yup.object().shape(
                                        filterSchema?.reduce((acc, filter) => {
                                            acc[filter.id] = Yup.string().required(`${filter.label} is required!`);
                                            return acc;
                                        }, {}) || {}
                                    )
                                }
                                onSubmit={async (values) => {
                                    sessionStorage.setItem(`filters_${serviceID}`, JSON.stringify(values));

                                    if (typeof setLocalFilters === 'function') {
                                        setLocalFilters(values);
                                        setFetchTrigger(prev => prev + 1);
                                    }
                                    try {
                                        let url = typee
                                            ? `${config.url.CONTEXT_READ_URL}${typee}`
                                            : `${config.url.CONTEXT_READ_URL}${apiEndPoint.api_end_point}`;

                                        const formData = new FormData();
                                        if (typee) {
                                            searchParams.forEach((val, key) => {
                                                if (key !== 'reportType') formData.append(key, val);
                                            });
                                            Object.entries(values).forEach(([key, val]) => {
                                                if (val) formData.append(key, val);
                                            });
                                        } else {
                                            const qp = new URLSearchParams();
                                            Object.entries(values).forEach(([key, val]) => {
                                                if (val) qp.append(key, val);
                                            });
                                            const qs = qp.toString();
                                            if (qs) url += url.includes('?') ? `&${qs}` : `?${qs}`;
                                        }
                                     const response =
  formData && [...formData.keys()].length > 0
    ? await CommonAxiosPost(url, formData)
    : await CommonAxiosGet(url);
                                        setDataSet(response?.data || response);
                                    } catch (error) {
                                        console.error("API Call error:", error);
                                        setDataSet(null);
                                    }
                                }}
                            >
                                {({ errors, touched, values, setFieldValue }) => (
                                    <Form>
                                        <div className="row g-3 align-items-end">
                                            {filterSchema.map((filter) => {
                                                // console.log("filter", filter)
                                                const isDisabled = filter.dependsOn &&
                                                    (Array.isArray(filter.dependsOn)
                                                        ? filter.dependsOn.some(pId => !values[pId])
                                                        : !values[filter.dependsOn]);

                                                const finalOptions = (filter.options && Array.isArray(filter.options) && filter.options.length > 0)
                                                    ? filter.options
                                                    : (Array.isArray(dynamicOptions[filter.id]) ? dynamicOptions[filter.id] : []);

                                                // const finalOptions = (filter.options && filter.options.length > 0)
                                                //     ? filter.options
                                                //     : (dynamicOptions[filter.id] || []);

                                                return (
                                                    <div key={filter.id} className="col-lg-3 col-md-4 col-sm-6 mb-2">
                                                        <label className="form-label fw-semibold text-muted mb-1" style={{ fontSize: '0.85rem' }}>
                                                            {filter.label} {filter.required && <span className="text-danger">*</span>}
                                                        </label>

                                                        {filter.type === 'select' && (
                                                            <Field
                                                                as="select"
                                                                name={filter.id}
                                                                disabled={isDisabled}
                                                                className={`form-select form-select-sm shadow-none ${touched[filter.id] && errors[filter.id] ? 'is-invalid' : ''}`}
                                                                onChange={async (e) => {
                                                                    const val = e.target.value;
                                                                    setFieldValue(filter.id, val);
                                                                    const updatedValues = { ...values, [filter.id]: val };
                                                                    const dependents = filterSchema.filter(f =>
                                                                        Array.isArray(f.dependsOn) ? f.dependsOn.includes(filter.id) : f.dependsOn === filter.id
                                                                    );

                                                                    dependents.forEach(async (child) => {
                                                                        setFieldValue(child.id, '');
                                                                        const parents = Array.isArray(child.dependsOn) ? child.dependsOn : [child.dependsOn];
                                                                        const allSelected = parents.every(pId => updatedValues[pId]);

                                                                        if (allSelected && child.apiEndpoint && (!child.options || child.options.length === 0)) {
                                                                            try {
                                                                                const params = parents.map(pId => `${pId}=${updatedValues[pId]}`).join('&');
                                                                                const res = await CommonAxiosGet(config?.url?.CONTEXT_READ_URL + `${child.apiEndpoint}?${params}`);

                                                                                // const responseData = res.data;

                                                                                // const keys = Object.keys(responseData);

                                                                                // const dataKey = keys.find(key =>
                                                                                //     key !== "status" &&
                                                                                //     !key.toLowerCase().endsWith("size") &&
                                                                                //     Array.isArray(responseData[key])
                                                                                // );

                                                                                // const finalData = dataKey ? responseData[dataKey] : [];

                                                                                setDynamicOptions(prev => ({ ...prev, [child.id]: res?.data?.data || [] }));
                                                                            } catch (err) {
                                                                                setDynamicOptions(prev => ({ ...prev, [child.id]: [] }));
                                                                            }
                                                                        }
                                                                    });
                                                                }}
                                                            >
                                                                <option value="">-- {filter.label} --</option>
                                                                {finalOptions.map((opt, i) => (
                                                                    <option key={opt.i} value={opt.id}>{opt.name}</option>
                                                                ))}
                                                            </Field>
                                                        )}
                                                        {filter.type === 'date' && (
                                                            <Field type="date" name={filter.id} className={`form-control form-control-sm shadow-none ${touched[filter.id] && errors[filter.id] ? 'is-invalid' : ''}`} />
                                                        )}
                                                        {filter.type === 'radio' && (
                                                            <div className="d-flex flex-wrap mt-1">
                                                                {filter.options?.map(opt => (
                                                                    <div key={opt.value} className="form-check form-check-inline me-3 mb-0">
                                                                        <Field type="radio" name={filter.id} id={`${filter.id}-${opt.value}`} value={opt.value} className="form-check-input shadow-none" style={{ cursor: 'pointer' }} />
                                                                        <label className="form-check-label" htmlFor={`${filter.id}-${opt.value}`} style={{ cursor: 'pointer', fontSize: '0.9rem' }} >
                                                                            {opt.label}
                                                                        </label>
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        )}
                                                        <ErrorMessage name={filter.id} component="div" className="text-danger mt-1" style={{ fontSize: '0.75rem', fontWeight: '500' }} />
                                                    </div>
                                                );
                                            })}
                                            <div className="col-lg-2 col-md-3 col-sm-12 mb-2">
                                                <button type="submit" className="btn btn-primary btn-sm w-100 fw-bold shadow-sm">
                                                    <i className="fa fa-search me-1"></i> Get Data
                                                </button>
                                            </div>
                                        </div>
                                    </Form>
                                )}
                            </Formik>
                        </div>
                    </div>
                )}
            </>)}
            {data && data.length > 0 ? (<>
             {tablehead && (
                <div className="heading-showmain">
    <div className="text-start fw-bold mb-4" style={{ fontSize: "17px" }}>
        {tablehead}
    </div>
    </div>
)}
                <div className="report-table-wrapper">
                    <div className="d-flex flex-wrap justify-content-between align-items-center mb-3 gap-3">
                        {/* <div>
                            {search === 'true' && (
                                <div className="input-group input-group-sm shadow-sm" style={{ width: '250px' }}>
                                    <span className="input-group-text bg-white border-end-0">
                                        <i className="bi bi-search text-muted"></i>
                                    </span>
                                    <input type="text" className="form-control border-start-0 shadow-none" placeholder="Search in report..."
                                        value={searchInput}
                                        onChange={(e) => {
                                            setSearchInput(e.target.value);
                                            setCurrentPage(1);
                                        }}
                                    />
                                </div>
                            )}
                        </div> */}


                        <div className="d-flex align-items-center gap-4">
                            <div>
                                {search === 'true' && (
                                    <div
                                        className="input-group input-group-sm shadow-sm feedbacksearch-bar-div"
                                        style={{
                                            width: '400px',
                                            borderRadius: '30px', // Rounded corners
                                            overflow: 'hidden',    // Ensures inner elements clip to the radius
                                            border: '1px solid #dee2e6' // Keeps the border consistent

                                        }}
                                    >
                                        <span className="input-group-text bg-white border-0 pe-1">
                                            <i className="bi bi-search text-muted"></i>
                                        </span>
                                        <input
                                            type="text"
                                            className="form-control border-0 shadow-none ps-2"
                                            placeholder="Search in report..."
                                            value={searchInput}
                                            onChange={(e) => {
                                                setSearchInput(e.target.value);
                                                setCurrentPage(1);
                                            }}
                                        />
                                    </div>
                                )}
                            </div>
                            <div className="d-flex gap-2">
                                <button
                                    type="button"
                                    className="btn btn-danger btn-sm me-2 custom-tooltip"
                                    data-tooltip="Download PDF"
                                    onClick={handlePDFDownload}
                                >
                                    <FaRegFilePdf className='inner-print-icon' />
                                </button>

                                {/* Excel Button */}
                                <button
                                    type="button"
                                    className="btn btn-success btn-sm me-2 custom-tooltip"
                                    data-tooltip="Download Excel"
                                    onClick={handleExcelDownload}
                                >
                                    <AiOutlineFileExcel className='inner-print-icon' />
                                </button>

                                {/* Print Button */}
                                <button
                                    className="btn btn-primary btn-sm custom-tooltip"
                                    data-tooltip="Print Page"
                                    onClick={() => handlePrint()}
                                >
                                    <SlPrinter className='inner-print-icon' />
                                </button>
                            </div>
                        </div>
                        <div>
                            {isPaginationEnabled && (
                                <div className="d-flex align-items-center text-muted fw-medium fs-7">
                                    <span>Show</span>
                                    <select className="form-select form-select-sm shadow-none mx-2" style={{ width: '85px' }} value={itemsPerPage}
                                        onChange={(e) => {
                                            setItemsPerPage(e.target.value === 'All' ? 'All' : Number(e.target.value));
                                            setCurrentPage(1);
                                        }}
                                    >
                                        {[10, 25, 50, 100, 'All'].map(val => (
                                            <option key={val} value={val}>{val === 'All' ? `All (${data.length})` : val}</option>
                                        ))}
                                    </select>
                                    <span>entries</span>
                                </div>
                            )}
                        </div>
                        {location?.search !== "" && (<>
                            <div>
                                <button type="button" className="btn btn-sm btn-light shadow-sm fw-bold border" onClick={() => { setItemsPerPage(10); navigate(-1); }}>
                                    <i className="bi bi-arrow-left me-1"></i> Back
                                </button>
                            </div>
                        </>)}
                    </div>
                    <div className="card shadow-sm report-table-card">
                        <div className="table-responsive report-table-scroll">
                            <table className="table table-hover table-bordered mb-0 align-middle custom-report-table" id="DataTable">
                                <thead className="shadow-sm">
                                    {renderMultiHeader(headings3)}
                                    {renderMultiHeader(headings2)}
                                    {renderMultiHeader(headings1)}
                                    <tr>
                                        {headings.map((item, index) => (
                                            <th key={index} className="text-center text-uppercase text-secondary">
                                                {item}
                                            </th>
                                        ))}
                                    </tr>
                                </thead>
                                <tbody className="bg-white">
                                    {slicedData.map((row, rowIndex) => {
                                        const isHighlight = row[4] === 'Circle Total' || row[2] === 'Sub Total';
                                        const rowClass = isHighlight ? "row-highlight-green" : "";
                                        const serialNumber = startIndex + rowIndex + 1;
                                        return (
                                            <tr key={rowIndex} className={rowClass}>
                                                <td className="text-center text-muted fw-bold">
                                                    {!isHighlight && isSerialNoReq !== 'false' ? serialNumber : ''}
                                                </td>

                                                {row.map((cell, colIndex) => {
                                                    const configIndex = colIndex + 1;
                                                    if (displays[configIndex] !== "Y") return null;

                                                    const alignMap = { "C": "center", "R": "right", "L": "left" };
                                                    const align = alignMap[aligns[configIndex]] || "left";
                                                    const link = links[configIndex];
                                                    const isTotalCol = totals[configIndex] === "T";
                                                    const isNumeric = datatypes[configIndex] === "I";
                                                    const cellText = cell !== null ? String(cell).trim() : "";

                                                    return (
                                                        <td key={colIndex} style={{ textAlign: align }}>
                                                            {link === "N" && isNumeric && isTotalCol && typeof cell === "number" ? (
                                                                <span>{formatNumberWithCommas(cell)}</span>
                                                            ) : link !== "N" && cellText !== "0" && !isHighlight ? (
                                                                <button type="button" className="btn btn-link btn-drilldown"
                                                                    onClick={() => {
                                                                        const targetUrl = `${link.substring(1)}${row[parseInt(link.substring(0, 1)) - 1]}`;
                                                                        navigate(`/services-dashboard/${targetUrl}`);
                                                                    }}
                                                                >
                                                                    {cell}
                                                                </button>
                                                            ) : (
                                                                <span dangerouslySetInnerHTML={{ __html: cellText }} />
                                                            )}
                                                        </td>
                                                    );
                                                })}
                                            </tr>
                                        );
                                    })}
                                </tbody>
                                <tfoot className="shadow-sm">
                                    {totals && totals.includes("T") && (<>
                                        <tr>
                                            <td colSpan="1" className="text-center text-uppercase text-secondary">Total</td>
                                            {totals.map((totalType, j) => {
                                                if (j > 0 && displays[j] === 'Y') {
                                                    if (totalType === 'T' && datatypes[j] === 'I') {
                                                        let t = data.reduce((sum, row) => {
                                                            if (row[4] !== 'Circle Total' && row[2] !== 'Sub Total' && !isNaN(row[j - 1]) && row[j - 1] !== null) {
                                                                return sum + parseFloat(row[j - 1]);
                                                            }
                                                            return sum;
                                                        }, 0);

                                                        return (
                                                            <td key={j} className="text-end text-dark">
                                                                {formatNumberWithCommas(parseFloat(t.toFixed(4)))}
                                                            </td>
                                                        );
                                                    }
                                                    return <td key={j}></td>;
                                                }
                                                return null;
                                            })}
                                        </tr>
                                    </>)}
                                    <tr>
                                        <td colSpan={displays.length}>
                                            {CONTEXT_NAME} Report Generated Date and Time : {reportgeneratedtime}
                                        </td>
                                    </tr>
                                </tfoot>
                            </table>
                        </div>
                        <div className="card-footer bg-white border-top-0 py-3">
                            <div className="row align-items-center">
                                <div className="col-md-6">
                                    <span className="text-muted fw-semibold" style={{ fontSize: '0.85rem' }}>
                                        Showing <span className="text-dark">{startIndex + 1}</span> to <span className="text-dark">{Math.min(startIndex + activeItemsPerPage, totalItems)}</span> of <span className="text-dark">{totalItems}</span> entries
                                    </span>
                                </div>
                                <div className="col-md-6">
                                    {pagination === 'true' && totalPages > 1 && paginationControls()}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>) : (
                <div className="card shadow-sm border-0 mt-4">
                    <div className="card-body text-center py-5">
                        {filterSchema?.length > 0 && fetchTrigger === 0 && !typee ? (<>
                            <p className="text-danger mb-0">Please select the required filters and click <b>'Get Data'</b> to view the report.</p>
                        </>) : (<>
                            <i className="bi bi-folder2-open text-danger mb-3" style={{ fontSize: '3rem', opacity: '0.5' }}></i>
                            <p className="text-muted mb-0">No records available for the selected criteria. Try changing your filters.</p>
                        </>
                        )}
                    </div>
                </div>
            )}
        </div>
    );
}